export default {
  main: {
    site_id: 18751727,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    terminalId: 35749,
    disableCheckTicketAfterLogin: true,
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketTimer: true,
    disableCashoutAfterLogin: true,
    timeFormat: "HH:mm",
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    signInType: "email",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    staffPassword: "0",
    websitePasswordHash: "277c5f7a7fccdcc770c8c9374c8b50a8e18b97dbc97f593c93e2945514a64c9c",

    termsAndConditions: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: true,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,

    availableLanguages: {
      "@replace": true,
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
      fra: {
        short: "FR",
        name: "Fra",
        order: 14,
      },
      chi: {
        short: "CH",
        name: "Chi",
        order: 9,
      },
    },
  },
  env: {
    lang: "spa",
  },
  splitScreen: false,
  verification: {
    enabled: true,
    required: true,
    externalValidation: false,
    payerValidation: false,
    findPlatformPlayer: true,
    amountValidation: false,
    betCreation: false,
    type: 'DNI',
    defaultCountryCode: 'PER',
    partner: 'tiorico',
    docTypes: [
      {
        name: 'DNI',
        type: 'DNI',
        default: true,
      }
    ],
  },
  terminal: {
    signInToAdmin: true,
  },
  upper_screen: {
    statistics_live: false,
    statistics_prematch: true,
    live_streaming: true,
    live_animations: true,
  },
  historyTabConfig: [
    {
      icon: "sports-section",
      title: "Sport",
    },
    {
      icon: "casino-7",
      title: "Casino",
    },
  ],
  sportsbook: {
    enableBoostedOdds: false,
    enablePredefinedMultiples: false,
    enableBannerAnimation: true,
  },
  userSection: {
    sections: ["betHistory"],
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
    },
    {
      url: "betting/prematch/all",
      name: "Sports",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  betslip: {
    enableCounterOffer: false,
    enableBookingBet: false,
    disableCounterOfferOnLive: false,
    enableBookingId: true,
    betDetailsOrder: ["total_odd", "stake_without_tax", "total_stake", "total_win"],
  },
  defaultTerminalParams: { pid: 18748567, tid: 35749, token: "suECGw==", currency: "PEN" },
};
